export default "__VITE_ASSET__CTCDmh8H__"